import * as Sentry from "@sentry/react";

const isLocalOrDev = import.meta.env.VITE_CONTEXT === "local" || import.meta.env.VITE_CONTEXT === "devshared";

const dsn = "https://a62b58768c5a225371b2a6b285af24fc@o4508654650982400.ingest.us.sentry.io/4508728337104896";
Sentry.init({
  dsn: dsn,
  integrations: [
    Sentry.browserApiErrorsIntegration({
      setTimeout: true,
      setInterval: true,
      requestAnimationFrame: true,
      XMLHttpRequest: true,
      eventTarget: true,
    }),
    Sentry.extraErrorDataIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.moduleMetadataIntegration(),
  ],
  release: import.meta.env.VITE_SOURCE_VERSION, // SOURCE_VERSION comes from heroku
  environment: import.meta.env.VITE_CONTEXT,
  enabled: !!import.meta.env.VITE_CONTEXT && !isLocalOrDev,
});

export class SwivlException {
  static capture(error: Error, message?: string, data?: any) {
    try {
      Sentry.captureException(error, { extra: { message, data: data } });
      if (message || error?.message) {
        console.error(message || error?.message, error, {
          message: message,
          errorMessage: error?.message,
          data: data,
        });
      }
    } catch (e) {
      console.error("Error capturing error", e);
    }
  }

  /**
   * Throws a test error to verify installation.
   * This function should only work in the local environment.
   */
  static throwTestError() {
    if (isLocalOrDev) {
      // Test error so that we can verify installation.
      // Should be disabled when the Sentry init is disabled via flag in Sentry.init.
      try {
        throw new Error(`Test error @ ${import.meta.env.VITE_CONTEXT}`);
      } catch (e: any) {
        SwivlException.capture(e, `[SENTRY] ${import.meta.env.VITE_CONTEXT} ${dsn}`);
        console.error(`Sending to sentry is ${!!import.meta.env.VITE_CONTEXT ? "enabled" : "disabled"}`);
      }
    }
  }
}
